module.exports = __webpack_public_path__ + "static/media/fiberglass.4bf60c9e.pdf";